<template>
  <div class="report-navbar">
    <div class="report-navbar-left">
      <div class="report-navbar-left__title">
        {{ t('report_navbar.title') }}
      </div>

      <ButtonNeutralSecondary
        v-if="props.rowList.length > 0"
        size="large"
        @click="emit('deleteRow')"
      >
        {{ t('report_navbar.button.delete') }}
      </ButtonNeutralSecondary>
      <ButtonNeutralSecondary
        v-if="props.rowList.length > 0"
        size="large"
        @click="emit('downloadRow')"
      >
        {{ t('report_navbar.button.download') }}
      </ButtonNeutralSecondary>
    </div>


    <div class="report-navbar-right">
      <Dropdown
        v-model="selectedFilterItem"
        :items="filterItemList.map((item) => item.name)"
        :is-visible="areTypesVisibles"
        :use-cross-icon="false"
        :use-searchbar="false"
        @update:model-value="val => emit('updateSelectedFilter', filterItemList.find((filter) => filter.name === val).value)"
        @close="areTypesVisibles = false"
      >
        <template #trigger>
          <div
            class="report-navbar__dropdown"
            :class="{'report-navbar__dropdown--active': areTypesVisibles}"
            @click="areTypesVisibles = !areTypesVisibles"
          >
            {{ filterItemList.find((filter) => filter.value === selectedFilter).name }}
            <ChevronDown
              :class="{'report-navbar__icon_active': areTypesVisibles}"
              class="report-navbar__dropdown_icon"
            />
          </div>
        </template>
      </Dropdown>
      <InputSearchSecondary
        :model-value="searchReportValue"
        :placeholder="t('report_navbar.placeholder.search')"
        @update:model-value="val => emit('updateSearchReportValue', val)"
      />
      <ButtonNeutralSecondary @click="fileInputRef.click()">
        <PlusBoldIcon />
        {{ t('report_navbar.button.upload') }}
        <input
          ref="fileInputRef"
          accept="application/pdf"
          type="file"
          hidden="hidden"
          @input="file => uploadFile(file.target.files[0])"
        >
      </ButtonNeutralSecondary>
    </div>
  </div>
</template>

<script setup>
import PlusBoldIcon from "@/components/Icons/PlusBoldIcon.vue";
import ChevronDown from "@/components/Icons/ChevronDown.vue";
import { t } from "@/controllerLK/GlobusLocalization";
import {ref, defineEmits, defineProps} from "vue";

const emit = defineEmits(["deleteRow", "downloadRow", "uploadFile", "updateSearchReportValue", "updateSelectedFilter"]);

const props = defineProps({
  selectedFilter: {
    type: Number,
    required: true,
    default: () => 0,
  },
  searchReportValue: {
    type: String,
    required: true,
    default: () => ""
  },
  rowList: {
    type: Array,
    required: true
  }
});

const fileInputRef = ref(null);
const areTypesVisibles = ref(false);

const filterItemList = [
  {
    value: 0,
    name: t("report_navbar.filter.first_new"),
  },
  {
    value: 1,
    name: t("report_navbar.filter.first_old"),
  },
  {
    value: 2,
    name: t("report_navbar.filter.by_name"),
  }];
  
const selectedFilterItem = ref(filterItemList.find((filter) => filter.value === props.selectedFilter).name);

const uploadFile = (file) => {
  emit("uploadFile", file);
  fileInputRef.value.value = "";
};
</script>

<style lang="scss" scoped>
.report-wrapper {
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #FFF;
  padding: 24px;
  border-radius: 10px;

  .report-navbar {
    display: flex;
    justify-content: space-between;

    &-right {
      display: flex;
      gap: 10px;
      align-items: center;
    }

    &-left {
      align-items: center;
      gap: 10px;
      display: flex;

      &__title {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
      }
    }

    &__dropdown {
      width: 150px;
      text-align: end;
      font-size: 14px;
      font-weight: 500;
      color: #212327;
      cursor: pointer;
      user-select: none;

      &:hover {
        color: #1F9AFF;
      }

      &--active {
        color: #1F9AFF;
      }
    }

    &__icon_active {
      transform: rotateX(180deg);
      color: #1F9AFF;
    }
  }
}
</style>
